<script setup lang="ts">
import { selectProps } from 'naive-ui';

const props = defineProps({
  ...selectProps,
  // Free-text tag entry (contract form): chips inline, Enter adds. No menu —
  // it's an input, not a picker.
  multiple: {
    type: Boolean,
    default: true,
  },
  tag: {
    type: Boolean,
    default: true,
  },
  filterable: {
    type: Boolean,
    default: true,
  },
  show: {
    type: Boolean,
    default: false,
  },
  showArrow: {
    type: Boolean,
    default: false,
  },
  placeholder: {
    type: String,
    default: 'Add a tag',
  },
});
</script>

<template>
  <!-- Tag input from the CM contract form — n-select in tag
       mode with the dropdown suppressed; chip/border chrome comes from the
       Tag and Input theme sections. -->
  <n-select v-bind="props" />
</template>
